import { Badge, Flex, Label } from "@braze/beacon-core";
import styled from "styled-components";


interface NumberTotalsProps {
    values: { "title" : string, "value" : number | string, "color" : string | undefined }[];
}

export const NumberTotals = ((props : NumberTotalsProps) => {

    return (
        <MetricsContainer>
            {props.values.map((v) => 
                {return (
                    <SingleValue title={v["title"]} value={v["value"]} color={v["color"]}/>
            )})}
        </MetricsContainer>
    )
});

const MetricsContainer = styled(`Flex`)`
    display: flex;
    flex-direction: column;
    min-width: 25%;
    height: 100%;
    justify-content: center;

    > * {
        &:not(:last-of-type) {
        margin-bottom: 0.5em;
        }
    }
`
const SingleValue = (({title, value, color} : {title : string, value : number | string, color : string | undefined}) => {
    const flexStyle = {
        justifyContent: "space-between",
        width: "100%",
        // height: "100%"
    }
    return (
        <Flex style={flexStyle}>
            <Label>{title}</Label>
            {typeof value == "number" &&  <Badge value={value} style={{backgroundColor: color}} truncateAfter={10000000} abbreviate={true}/>}
            {typeof value == "string" &&  <Label>{value}</Label>}
        </Flex>
    )
})